import Badge from './badge'
import ClickOutside from './click-outside'
import Resize from './resize'
import Ripple from './ripple'
import Scroll from './scroll'
import Tooltip from './tooltip'
import Touch from './touch'

export {
  Badge,
  ClickOutside,
  Ripple,
  Resize,
  Scroll,
  Tooltip,
  Touch
}



// WEBPACK FOOTER //
// ./src/directives/index.js